import { render } from "./MatchingDropdown.vue?vue&type=template&id=fffccb66&scoped=true"
import script from "./MatchingDropdown.vue?vue&type=script&lang=js"
export * from "./MatchingDropdown.vue?vue&type=script&lang=js"

import "./MatchingDropdown.vue?vue&type=style&index=0&id=fffccb66&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fffccb66"]])

export default __exports__